export const environment = {
    production: false,
    baseUrl: "https://mosaic.lst.uni-saarland.de",
    apiUrl: "https://mosaic.lst.uni-saarland.de/api",
    appRoles: {
        "ADMIN": "Admin",
        "USER": "User",
        "STUDENT": "Student"
    }
};
